<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        企业场景信息
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.comparyName">
            <el-input
              v-model="slotForms.forms.comparyName"
              placeholder="企业名称"
              clearable
            ></el-input>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <el-table-column
          label="序号"
          width="50"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          label="企业名称"
          prop="comparyName"
          width="200"
          fixed
          show-overflow-tooltip
        />
        <el-table-column label="车辆总数" prop="vehicleNum">
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.vehicleNum > 0"
              :to="{
                path: '/baseVehicleList',
                query: { vehicleIds: scope.row.vehicleIds }
              }"
              style="color: #0000FF;"
            >
              {{ scope.row.vehicleNum }}
            </router-link>
            <span v-else>{{ scope.row.vehicleNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="冷库总数" prop="storageNum">
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.storageNum > 0"
              :to="{
                path: '/baseStorageList',
                query: { comparyName: scope.row.comparyName }
              }"
              style="color: #0000FF;"
            >
              {{ scope.row.storageNum }}
            </router-link>
            <span v-else>{{ scope.row.storageNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="前置仓总数" prop="leadStorageNum">
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.leadStorageNum > 0"
              :to="{
                path: '/baseStorageList',
                query: { comparyName: scope.row.comparyName, storageType: 2 }
              }"
              style="color: #0000FF;"
            >
              {{ scope.row.leadStorageNum }}
            </router-link>
            <span v-else>{{ scope.row.leadStorageNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="区位总数" prop="storageAreaNum">
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.storageAreaNum > 0"
              :to="{
                path: '/baseStorageAreaList',
                query: { comparyName: scope.row.comparyName }
              }"
              style="color: #0000FF;"
            >
              {{ scope.row.storageAreaNum }}
            </router-link>
            <span v-else>{{ scope.row.storageAreaNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="门店总数" prop="storeNum">
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.storeNum > 0"
              :to="{
                path: '/baseStoreList',
                query: { comparyName: scope.row.comparyName }
              }"
              style="color: #0000FF;"
            >
              {{ scope.row.storeNum }}
            </router-link>
            <span v-else>{{ scope.row.storeNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="冷柜总数" prop="freezerNum">
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.freezerNum > 0"
              :to="{
                path: '/baseFreezerList',
                query: { freezerIds: scope.row.freezerIds }
              }"
              style="color: #0000FF;"
            >
              {{ scope.row.freezerNum }}
            </router-link>
            <span v-else>{{ scope.row.freezerNum }}</span>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
  </div>
</template>

<script>
import { FetchFindByPage } from "@/api/base/comparyGroup";
import { mapActions, mapGetters } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";

export default {
  mixins: [resizeListener, operationManage],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      formExtend: {
        forms: {
          comparyName: "",
          comparyTypeId: "",
          countyNameId: ""
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      columSetVisible: false,
      multipleSelection: [],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      errMess: "",
      loading: "false",
      //导出URL
      exportUrl: "/base/comparyGroup/exportComparyGroup?"
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"])
  },
  created() {
    this.FetchFindByPage(this.mergeObj());
  },
  methods: {
    // 获取表格数据
    FetchFindByPage(response) {
      this.loading = true;
      FetchFindByPage(response)
        .then(response => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            this.tableData = response.result.data;
            this.total = response.result.totalRecords;
          }
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        curPage: this.curPage,
        pageSize: this.pageSize
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    handleExportClick() {
      let param = "";
      param += "&comparyName=" + this.formExtend.forms.comparyName;

      document.location.href = this.exportUrl + param;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
